<div class="app-shell">
  <app-navbar></app-navbar>

  <main class="app-main" style="background-color: #ffffff !important">
    <header class="app-topbar">
      <div class="app-topbar__spacer"></div>
      <div class="app-user">
        Bem-vindo, Miguel
        <span class="avatar">M</span>
      </div>
    </header>

    <section class="app-content" style="background-color: #ffffff !important">
      <router-outlet></router-outlet>
    </section>
  </main>
</div>
